import type { EcommerceItem, EcommercePricedItem } from '../models-gtm'

export const getDedupedCartItems = (cartItems: EcommerceItem[]): EcommerceItem[] => {
    const cartItemsDictionary: {
        [key: string]: EcommercePricedItem
    } = {}
    cartItems.forEach(cartItem => {
        const existingCartItem = cartItemsDictionary[cartItem.item_id]
        cartItemsDictionary[cartItem.item_id] = {
            ...cartItem,
            quantity: existingCartItem && existingCartItem.quantity ? existingCartItem.quantity + 1 : 1,
        }
    })

    return Object.values(cartItemsDictionary)
}
